// Acceder a las variables de entorno para la API key y los IDs de grupo
export const MAILER_LITE_API_KEY = process.env.REACT_APP_MAILER_LITE_API_KEY || '';

export const GROUP_IDS = {
  AUTOESTIMA: process.env.REACT_APP_GROUP_ID_AUTOESTIMA || '',
  ANSIEDAD: process.env.REACT_APP_GROUP_ID_ANSIEDAD || '',
  ESTRES: process.env.REACT_APP_GROUP_ID_ESTRES || '',
  INSOMNIO: process.env.REACT_APP_GROUP_ID_INSOMNIO || '',
  TRISTEZA: process.env.REACT_APP_GROUP_ID_TRISTEZA || '',
  RUPTURA_PAREJA: process.env.REACT_APP_GROUP_ID_RUPTURA_PAREJA || ''
};

export const REDIRECT_URLS = {
  AUTOESTIMA: process.env.REACT_APP_REDIRECT_URL_AUTOESTIMA || '',
  ANSIEDAD: process.env.REACT_APP_REDIRECT_URL_ANSIEDAD || '',
  ESTRES: process.env.REACT_APP_REDIRECT_URL_ESTRES || '',
  INSOMNIO: process.env.REACT_APP_REDIRECT_URL_INSOMNIO || '',
  TRISTEZA: process.env.REACT_APP_REDIRECT_URL_TRISTEZA || '',
  RUPTURA_PAREJA: process.env.REACT_APP_REDIRECT_URL_RUPTURA_PAREJA || ''
};

export const APPOINTMENT_URL = process.env.REACT_APP_APPOINTMENT_URL || '';
